// initial state
import axios from "axios";

const state = () => ({
    currencies: []
})

// getters
const getters = {}

// actions
const actions = {
    async getData ({ commit }) {
        axios.get(route('admin.bank-accounts.getData')).then(result => {
            commit('setCurrencies', result.data.currencies)
        });
    }
}

// mutations
const mutations = {
    setCurrencies (state, currencies) {
        state.currencies = currencies
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
